<div class="main-container">
  <div class="main-message-container-content">
    <h3>Sorry, MyDHL Breakbulk is temporarily unavailable.</h3>
    <br />
    <p>
      Our site will be available shortly. If you have urgent need, please contact your local DHL
      Support team.
    </p>
  </div>
  <!-- </div> -->
</div>
